/* istanbul ignore file */
import { optional as codecOptional, string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { CourseTier } from './CourseTier';
const CreateCourseDataParser = /* #__PURE__ */ parsers.object([
    ['name', codecString],
    ['tenantId', /* #__PURE__ */ codecOptional(codecString), 'tenant_id'],
    ['tier', /* #__PURE__ */ codecOptional(CourseTier)],
]);
export class CreateCourseData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return CreateCourseDataParser.decode(input).map(res => new CreateCourseData(res));
    }
    static unsafeDecode(input) {
        return CreateCourseData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CreateCourseDataParser.encode(data);
    }
    static schema() {
        return CreateCourseDataParser.schema();
    }
}
